import * as action_types from "./constants";
import { api } from "../../../../services/api"
import { portalService } from "../../../../configs/constants";
import axios from "axios";

export const getUserList = () => {
  return async (dispatch) => {

    const response = await api.getAllUsers()

    dispatch({
      type: action_types.GET_USERS,
      data: response?.data,
    });
  };
};

export const getACLGroups = () => {
  return async (dispatch) => {

    const response = await api.getACLGroups()

    dispatch({
      type: action_types.GET_ACL_GROUPS,
      data: response?.data,
    });
  };
};


export const sendBulkNotification = async (body: object) => {
  try {
    const url = `${portalService}/communication/sendBulk`;
    const { data } = await axios.post(url, body);
    return data;

  } catch (error) { console.log("err",error); throw error?.response; }
};
